//import { TextField, TextFieldProps } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import React, { PropsWithChildren, type JSX } from 'react';
import { Controller, useFormContext } from "react-hook-form";
import { FormFieldPropsBase } from "../form/Form";
import DefaultDatePicker from "../../default-date-picker/DefaultDatePicker";

export type FormDatePickerProps = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rules?: any;
    views?: Array<"month" | "year" | 'day'>;
} & FormFieldPropsBase;

export default function FormDatePicker({
    name,
    id,
    // testId,
    label,
    ariaLabel,
    readOnly,
    helperText,
    rules,
    sx,
    disabled,
    views,
    showID
}: PropsWithChildren<FormDatePickerProps>): JSX.Element {
    const { control } = useFormContext();

    // function textField(props: TextFieldProps) {

    //     return (
    //         <TextField
    //                 variant="filled"
    //                 id={id}
    //                 data-testid={testId}
    //                 aria-label={ariaLabel ?? undefined}
    //                 helperText={props.helperText}
    //                 error={props.error}
    //                 InputLabelProps={{
    //                     shrink: true,
    //                 }}
    //                 onBlur={props.onBlur}
    //                 {...props}
    //                 sx={{
    //                     marginTop: 0,
    //                     width: 1,
    //                     ...sx,
    //                 }}
    //             />
    //     )
    // }


    return (
        <Controller
            control={control}
            name={name}
            rules={rules}
            render={
                ({
                    field: { ref, /*name,*/ value, onChange, onBlur },
                    fieldState: { invalid, /*isTouched, isDirty,*/ error },
                    // formState
                }
                // : {
                //     field: any;
                //     fieldState: any;
                //     formState: any;
                // }
                ) => (
                    <LocalizationProvider dateAdapter={AdapterDateFns}>

                        <DefaultDatePicker
                            id={id}
                            showID={showID}
                            disabled={disabled}
                            value={value}
                            label={label}
                            readOnly={readOnly}
                            onChange={onChange}
                            views={views}
                            inputRef={ref}
                            slotProps={{
                                textField: {
                                    onBlur: onBlur,
                                    error: invalid,
                                    id: id,
                                    variant: 'filled',
                                    "aria-label": (ariaLabel ?? undefined),
                                    helperText: invalid ? error?.message : helperText,
                                    slotProps: {
                                        inputLabel: {
                                            shrink: true
                                        },
                                    },
                                }
                            }}
                            // slots={{
                            //     textField: textField
                            // }}
                            sx={{...sx}}
                        />
                        {/* <DatePicker
                            disabled={disabled}
                            renderInput={
                                (props: TextFieldProps) =>
                                    <TextField
                                        variant="filled"
                                        id={id}
                                        data-testid={testId}
                                        aria-label={ariaLabel ?? undefined}
                                        error={invalid}
                                        helperText={invalid ? error.message : helperText}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        onBlur={onBlur}
                                        {...props}
                                        sx={{
                                            marginTop: 0,
                                            width: 1,
                                            ...sx,
                                        }}
                                    />
                            }
                            label={label}
                            value={value}
                            readOnly={readOnly}
                            onChange={onChange}
                            inputRef={ref}
                            views={views}
                        /> */}
                    </LocalizationProvider>
                )
            }
        />
    );
}